module.exports = __webpack_public_path__ + "media/assets/faria_products/AP-DP-0f70f99056086a1af7c7ac1336c7dddfa21e4bc51af1643629fe263d70754330.svg";